"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const class_validator_1 = require("class-validator");
const class_transformer_1 = require("class-transformer");
const base_models_1 = require("@integration/base-models");
const BaseIncentive_1 = tslib_1.__importDefault(require("../../incentives/BaseIncentive"));
const IncentiveSettlement_1 = tslib_1.__importDefault(require("../../incentives/IncentiveSettlement"));
class GetNextBestOfferResponseOfferIncentiveV2 extends BaseIncentive_1.default {
}
tslib_1.__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsUUID)(),
    (0, base_models_1.Docs)({ example: '4db7554c-e5cc-4c31-82b0-8bc7d134c0f7', description: 'Incentive UUID' }),
    tslib_1.__metadata("design:type", String)
], GetNextBestOfferResponseOfferIncentiveV2.prototype, "incentiveId", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsNumber)(),
    (0, base_models_1.Docs)({ example: 80, description: 'Total offer value' }),
    tslib_1.__metadata("design:type", Number)
], GetNextBestOfferResponseOfferIncentiveV2.prototype, "totalValue", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.ValidateNested)({ each: true }),
    (0, class_transformer_1.Type)(() => IncentiveSettlement_1.default),
    tslib_1.__metadata("design:type", Array)
], GetNextBestOfferResponseOfferIncentiveV2.prototype, "settlements", void 0);
exports.default = GetNextBestOfferResponseOfferIncentiveV2;
